export default __webpack_public_path__ + "static/media/ADD_WHITE.b2fd7187.svg";